import { derived, readable, writable } from 'svelte/store';
import { InitialDeliveryRequest, Page, PageResponse, Product, ProductId, SendEmailRequest } from '../proto/products_pb';
import { searchStore } from './state'; // import combined search store
import { idToken } from './id_token';
import { ProductServiceClient, ListProductsRequest } from '../proto/products_grpc_web_pb';

/**
 * @type {PageResponse}
 * */
let currentPageResponseValue = undefined;
export const changePage = () => {
    // get the current page
    // increment the page number
    // see if that page would overflow the total pages
    // if so, do nothing
    // else, set the current page to the new page
    // and listProducts()
    console.log('changePage');

    const page = currentPageValue.getPage();
    const newPage = page;
    if (currentPageResponseValue === undefined) return;
    if (newPage > currentPageResponseValue.getTotalpages() || newPage < 1) {
        // if we search for something else  and the user reset,
        // we don't want  to be stuck on the last page
        if (currentPageValue !== initialPage) {
            // only if they didn't reset, we do nothing
            return;
        }
    }
    listProducts();
}
const PAGE_SIZE = 20;  // Adjust as needed
const initialPage = new Page();
initialPage.setSize(PAGE_SIZE);
initialPage.setPage(1);
/**
 * @type {import('svelte/store').Writable<Page>}
 * */
export const currentPage = writable(initialPage);
/**
 * @type {Page}
 **/
let currentPageValue = new Page();
currentPage.subscribe(value => {
    currentPageValue = value;
    console.log("currentPage.subscribe");
    changePage();
});

let metadata;
idToken.subscribe(value => {
    metadata = {};
    if (value == null) return;
    metadata['authorization'] = `Bearer ${value.token}`;
});
  

/**
 * Method to process items, phone number and address
 * @param {Array} items - The items to process.
 * @param {string} phoneNumber - The phone number to process.
 * @param {string} address - The address to process.
 * @param {string} deliveryArea - The delivery area to process.
 */
export async function sendEmail(items, phoneNumber, address, deliveryArea) {
    // Insert your code here
    const request = new SendEmailRequest();
    request.setProductsList(items);
    request.setAddress(address);
    request.setPhonenumber(phoneNumber);
    request.setDeliveryarea(deliveryArea);
    console.log("Sending email request: ", request);

    const res = await new Promise((resolve, reject) => {
        client.sendEmail(request, metadata, (err, response)=> {
            if (err) {
                reject(err);
                console.log(err);
            } else {
                resolve(response);
            }
        });
    });
    return res.getOrderid();
}


const client = new ProductServiceClient(`${SERVER_IP}`, null, {});

/**
 * @type {import('svelte/store').Writable<Array<Product>>}
 */
export const products = writable([]);
/**
 * @type {import('svelte/store').Writable<PageResponse>}
 * */
export const currentPageResponse = writable(new PageResponse())
currentPageResponse.subscribe(value => {
    currentPageResponseValue = value;
    console.log("currentPageResponse: ", value);
});

export let query;
export let categoryValue;
export let initialLoaded = false;
searchStore.subscribe(({ query: q, category: c }) => {
    query = q;
    categoryValue = c === '' ? null : c;
    listProducts();
});




/**
 * @type {import('svelte/store').Readable<number>}
 * */
export const totalPages = derived(currentPageResponse, $currentPageResponse => $currentPageResponse.getTotalpages());

let totalPagesValue;
totalPages.subscribe(value => {
    totalPagesValue = value;
});


/**
 * @returns {Promise<void>}
 * */
export async function listProducts() {
    console.log("listProducts");
    const request = new ListProductsRequest();
    const page = new Page();
    if (currentPageValue === undefined) {
        currentPageValue = new Page();
    }
    page.setPage(currentPageValue.getPage());
    page.setSize(currentPageValue.getSize());
    request.setPage(page);
    request.setSearch(query);
    if (categoryValue !== null) {
        request.setSubcategory(categoryValue);
    }
    // print request
    console.log(request);

    const newProducts = await new Promise((resolve, reject) => {
        client.listProducts(request, metadata, (err, response)=> {
            if (err) {
                reject(err);
                console.log(err);
            } else {
                resolve(response);
            }
        });
    });

    // Apply 5% discount to each product

    /**
     * @type {Array<Product>}
     */
    const productList = newProducts.getProductsList();
    const defualtDiscount = 0.05;

    const productsWithDiscount = productList.map((product) => {
        const discountedPrice = product.getPrice() * (1 - defualtDiscount);
        if (product.getDiscountedprice() === 0) {
            product.setDiscountedprice(discountedPrice);
        }
        return product;
    });

    products.set(productsWithDiscount);
    currentPageResponse.set(newProducts.getPage());
    console.log("new products: ", productsWithDiscount);
    initialLoaded = true;
    
    // Track search results if there's a query
    if (query && query.trim().length > 0) {
        searchStore.trackSearchResults(productsWithDiscount.length);
    }
}

/**
 * @param {Product} product
 * @returns {Promise<void>}
 * */
export async function updateProduct(product) {
    await new Promise((resolve, reject) => {
        client.updateProduct(product, metadata, (err, response) => {
            if (err) {
                reject(err);
                console.log(err);
            } else {
                resolve(response);
            }
        });
    });
    await listProducts();
}

/**
 * @param {Product} product
 * @returns {Promise<void>}
 * */
export async function removeProduct(product) {
    const response = await new Promise((resolve, reject) => {
        const productId = new ProductId();
        productId.setId(product.getId());
        client.deleteProduct(productId, metadata, (err, response) => {
            if (err) {
                reject(err);
                console.log(err);
            } else {
                resolve(response);
            }
        });
    });
    console.log(response);
    await listProducts()
}

/**
 * @param {Product} product
 * @returns {Promise<void>}
 * */
export async function createProduct(product) {
    const response = await new Promise((resolve, reject) => {
    client.createProduct(product, metadata, (err, response) => {
            if (err) {
                reject(err);
                console.log(err);
            } else {
                resolve(response);
            }
        });
    });
    await listProducts();
    console.log(response);
}

listProducts();


/**
 * 
 * @param {Product} product 
 * @returns { boolean }
 */
export function hasDiscount(product) {
    if (product.getDiscountedprice() === undefined) {
        return false;
    }
    if (product.getDiscountedprice() === product.getPrice()) {
        return false;
    }
    return true;

}




// Makes a request to the proto endpoing for delivery discount
export async function updateDeliveryDiscount() {
    /**
     * @type {number} // mark var as int
     */
    const discount = await new Promise((resolve, reject) => {
        client.getInitialDelivery(new InitialDeliveryRequest(), metadata, (err, response) => {
            if (err) {
                reject(err);
                console.log(err);
            } else {
                console.log("Delivery discount: ", response);
                resolve(response.getDeliveryPricePercentageDiscount());
            }
        });
    });
    deliveryDiscountPercentage.set(discount);
}

/**
 * @type {import('svelte/store').Writable<number>}
 */
export const deliveryDiscountPercentage = writable(0.0);
